export enum OwnershipClaimStatus {
  open= 'open',
  accepted = 'accepted',
  rejected = 'rejected',
}

/**
 * Labels shown to the user. The back-end keeps the English values, the CMS is Dutch.
 */
export const OWNERSHIP_CLAIM_STATUS_LABEL: Record<OwnershipClaimStatus, string> = {
  [OwnershipClaimStatus.open]: 'Open',
  [OwnershipClaimStatus.accepted]: 'Geaccepteerd',
  [OwnershipClaimStatus.rejected]: 'Geweigerd',
};
